import React from "react";
import * as Dropdown from "@radix-ui/react-dropdown-menu";
import { DropdownRadioItemProps } from "./Dropdown.types";
import * as S from "./RadioItem.styles";

/**
 * RadioItem component for the Dropdown menu
 *
 * @param props - The component props
 * @returns A Dropdown RadioItem component
 */
export const RadioItem = React.forwardRef<
  React.ElementRef<typeof Dropdown.RadioItem>,
  DropdownRadioItemProps
>(function RadioItem({ children, id, ...props }, forwardedRef) {
  // Generate a unique ID if not provided
  const uniqueID = React.useId();
  const radioId = id || `radioItem-${uniqueID}`;

  return (
    <S.Item
      {...props}
      onSelect={event => {
        event.preventDefault();
        if (props.onSelect) {
          props.onSelect(event);
        }
      }}
      ref={forwardedRef}
    >
      <S.Radio
        id={radioId}
        label={children}
        value={props.value}
        disabled={props.disabled}
      />
    </S.Item>
  );
});
